import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import './styles/base.css';
import './ui/ui.css';
import './ui/select.css';

const container = document.getElementById('root');
// Falha alto e cedo: um root ausente em produção vira tela branca silenciosa.
if (!container) throw new Error('Elemento #root não encontrado no documento.');

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
